import { useAuth } from "@clerk/react";
import { useQuery } from "@tanstack/react-query";
import { getOnboardingStatus } from "./onboarding-submission";

export function useOnboardingStatus() {
  const { isLoaded, isSignedIn, userId, getToken } = useAuth();
  return useQuery({
    queryKey: ["onboarding-status", userId],
    queryFn: () => getOnboardingStatus(getToken),
    enabled: isLoaded && !!isSignedIn,
    staleTime: 0,
    retry: 1,
  });
}